import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'sonner';
import { App } from './App.tsx';
import { AuthProvider } from './lib/auth.tsx';
import { iniciarPwa } from './lib/pwa.ts';
import { queryClient } from './lib/query.ts';
import { ErrorBoundary, iniciarSentry } from './lib/sentry.ts';
import './styles/tokens.css';

iniciarSentry();
// Aplicación instalable: el ofrecimiento «Instalar» puede llegar en cuanto carga; el service worker, solo en producción
iniciarPwa(MG_BUILD);

function PantallaError({ resetError }: { resetError: () => void }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-xl font-semibold">Algo salió mal en la pantalla</h1>
      <p className="text-sm text-muted-foreground">
        El error quedó registrado. Recarga la página; si se repite, avisa al administrador.
      </p>
      <button
        type="button"
        className="rounded-md border px-4 py-2 text-sm"
        onClick={() => {
          resetError();
          window.location.reload();
        }}
      >
        Recargar
      </button>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={({ resetError }) => <PantallaError resetError={resetError} />}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
            {/* Abajo a la izquierda: arriba tapaba la tasa, la campana y el menú, y abajo a la derecha taparía «Cobrar» del punto de venta (auditoría de frontend FE-11) */}
            <Toaster position="bottom-left" richColors closeButton />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
